export function filterItems (result, searchValue) {
    var filter = result.filter(_ => {
        return _.name?.toLowerCase().includes(searchValue.toLowerCase())
     || _.tool?.name?.toLowerCase().includes(searchValue.toLowerCase())
     || _.description?.toLowerCase().includes(searchValue.toLowerCase())
     || _.id.toString() === searchValue.toString()
     || (_.isHerb && searchValue.toLowerCase().includes("herb"))
     || (_.isPotion && searchValue.toLowerCase().includes("potion"))
   })

   return filter;
}